// extracted by mini-css-extract-plugin
export var callCard = "_nk-0";
export var callMessageButton = "_nk-1";
export var helpIcon = "_nk-3";
export var helpIconContainer = "_nk-4";
export var verticalDivider = "_nk-2";